@for (item of rowItem(); track $index) {
<div
  class="rounded-6 bg-[#FFE2E4] flex justify-between min-h-20 py-4 px-5 items-center gap-5"
>
  <div class="animate-pulse bg-[#DDDEE0] w-36 h-10 max-sm:h-5"></div>
  <div class="flex items-center gap-5">
    <div class="animate-pulse bg-[#DDDEE0] w-5 h-5 rounded-full"></div>
    <div class="bg-white text-[#666666] w-20 rounded-100 px-3 py-1">
      <div class="animate-pulse bg-[#DDDEE0] w-full h-4"></div>
    </div>
    <div class="animate-pulse bg-[#DDDEE0] w-5 h-5 rounded-full"></div>
  </div>
</div>
<div class="flex flex-col gap-4 py-4">
  @for ( item of nSubItem; track $index) {
  <div
    class="bg-white rounded-6 grid grid-cols-12 items-center min-h-11 px-4 py-3 gap-3 max-sm:gap-2 max-sm:px-2.5 max-sm:py-4"
  >
    <div
      class="col-span-2 max-sm:col-span-2 w-[110px] h-10 max-sm:w-[2.4rem] max-sm:h-[17px] object-contain"
    >
      <div class="animate-pulse bg-[#DDDEE0] w-[85%] h-full"></div>
    </div>
    <div
      class="flex items-center col-span-5 gap-2 max-sm:col-span-5 max-sm:gap-1"
    >
      @for (data of items; track $index) {
      <div
        class="flex items-center justify-center w-8 h-8 border-2 rounded-full border-grey-15 max-sm:w-5 max-sm:h-5"
      >
        <div class="animate-pulse bg-[#DDDEE0] w-5 h-5 rounded-full"></div>
      </div>
      }
    </div>

    <div
      class="flex items-center justify-center col-span-3 gap-2 max-md:col-span-2 max-sm:col-span-3 max-sm:gap-1"
    >
      <div
        class="animate-pulse bg-[#DDDEE0] w-full h-5 max-md:w-8 max-md:h-3"
      ></div>
    </div>
    <div class="flex justify-center col-span-1 max-sm:col-span-1">
      <div class="animate-pulse bg-[#DDDEE0] w-5 h-5 rounded-full"></div>
    </div>
    <div class="flex justify-center col-span-1 max-sm:col-span-1">
      <div class="animate-pulse bg-[#DDDEE0] w-5 h-5 rounded-full"></div>
    </div>
  </div>
  }
</div>
}
